/* Full-page quick-entry selection. The shared draft bag has no commerce writes. */
(() => {
  'use strict';
  const quantity = value => Math.min(10, Math.max(1, Math.floor(Number(value) || 1)));
  function calculate(option, value) {
    const qty = quantity(value);
    const numbers = ['price','base','bonus','multiplier','campaignBonus'].map(key => Number(option.dataset[key]));
    if (numbers.some(n => !Number.isSafeInteger(n) || n < 0) || numbers[0] < 5000 || numbers[3] < 1) return null;
    const [price,base,bonus,multiplier,campaignBonus] = numbers;
    const entriesPerPackage = base * multiplier + bonus + campaignBonus;
    if (![price*qty,entriesPerPackage*qty].every(Number.isSafeInteger)) return null;
    return {qty,title:option.dataset.title,cents:price*qty,entries:entriesPerPackage*qty,base,bonus,multiplier,campaignBonus};
  }
  const money = cents => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(cents/100);
  const count = value => value.toLocaleString('en-US');
  function routeOption(href,options){
    const handle=new URL(href).searchParams.get('quick_entry');
    return handle?options.find(option=>option.dataset.handle===handle||option.value===handle):undefined;
  }
  function pageURL(href,handle){
    const url=new URL(href);url.searchParams.set('quick_entry',handle);url.hash='';return url.href;
  }
  function init(root = document) {
    root.querySelectorAll('[data-entry-packages]').forEach(section => {
      if (section._entryDispose) return;
      const options = [...section.querySelectorAll('[data-entry-option]')];
      const input=section.querySelector('[data-entry-quantity]'),review=section.querySelector('[data-entry-review]'),page=section.querySelector('[data-entry-page]');
      const minus=section.querySelector('[data-entry-minus]'),plus=section.querySelector('[data-entry-plus]'),selection=section.querySelector('[data-entry-selection]');
      const dock=section.parentElement.querySelector('[data-entry-dock]');
      const listeners=[];let bagItems=[];
      const homeTitle=document.title;
      const on=(target,name,handler)=>{target?.addEventListener(name,handler);listeners.push(()=>target?.removeEventListener(name,handler));};
      const grid=section.querySelector('.th-entry-grid');
      const move=direction=>{const card=grid?.querySelector('.th-entry-product');if(!card)return;grid.scrollBy({left:direction*(card.getBoundingClientRect().width+16),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
      on(section.querySelector('[data-entry-prev]'),'click',()=>move(-1));
      on(section.querySelector('[data-entry-next]'),'click',()=>move(1));
      const set=(selector,value)=>{const el=section.querySelector(selector);if(el)el.textContent=value;};
      if (!options.length||!page) return;
      if (!options.some(option=>option.checked)) options[0].checked=true;
      function update() {
        const option=options.find(item=>item.checked),total=option&&calculate(option,input.value);
        review.disabled=!total;
        if(!total){set('[data-entry-total]','Unavailable');return null;}
        const finish=option.dataset.entryFinish;
        page.dataset.entryFinish=['bronze','platinum','gold','obsidian'].includes(finish)?finish:'bronze';
        minus.disabled=total.qty<=1;plus.disabled=total.qty>=10;
        set('[data-entry-summary]',`${total.entries.toLocaleString('en-US')} entries`);
        const edition=total.title.replace(/^The /,'');
        const perPackage=total.entries/total.qty;
        set('[data-entry-total]',money(total.cents));set('[data-entry-unit-price]',money(total.cents/total.qty));
        set('[data-entry-review-package]',`${edition} Easy ${count(perPackage)} Entries`);
        section.querySelector('[data-entry-art]')?.setAttribute('aria-label',`THEIAN ${edition} Quick Entry ticket`);
        set('[data-entry-description-title]',`${edition} Easy Entries`);
        set('[data-entry-promise]',`${count(perPackage)} entries. One package.`);
        const inCart=bagItems.find(item=>item.id==='entry-'+option.value)?.qty||0;
        set('[data-entry-in-cart]',inCart?`(${inCart} in cart)`:'');
        section.querySelector('[data-entry-multiple]').hidden=total.qty===1;
        set('[data-entry-breakdown]',`Per package: ${count(total.base)} base entries × ${count(total.multiplier)} + ${count(total.bonus)} package bonus + ${count(total.campaignBonus)} campaign bonus = ${count(total.entries/total.qty)} entries. Quantity: ${total.qty}.`);
        set('[data-entry-review-count]',count(perPackage));
        const passImage=section.querySelector('[data-entry-card-image]');
        if(passImage&&option.dataset.image){
          passImage.src=option.dataset.image;
          passImage.alt=`THEIAN ${money(total.cents/total.qty).replace('.00','')} Digital Entry Pass · ${count(perPackage)} entries`;
        }
        if(!page.hidden)document.title=`${edition} Easy ${count(perPackage)} Entries | THEIAN`;
        return total;
      }
      function renderRoute({focus=false,scroll=false}={}){
        const option=routeOption(location.href,options);
        page.hidden=!option;
        document.documentElement.classList.toggle('th-quick-entry-view',Boolean(option));
        section.setAttribute('aria-labelledby',option?page.querySelector('h1').id:section.querySelector('.th-entry-heading h2').id);
        if(option){
          options.forEach(item=>item.checked=item===option);input.value=1;update();
          document.querySelectorAll('[data-dream-background]').forEach(video=>video.pause());
          if(scroll)window.scrollTo({top:0,behavior:'instant'});
          if(focus)page.querySelector('h1').focus({preventScroll:true});
        }else document.title=homeTitle;
        document.dispatchEvent(new CustomEvent('th-entry-route-change',{detail:{open:Boolean(option)}}));
      }
      function openPage(option){
        if(page.hidden)history.replaceState({...history.state,thEntryScroll:window.scrollY},'',location.href);
        history.pushState({...history.state},'',pageURL(location.href,option.dataset.handle));
        renderRoute({focus:true,scroll:true});
      }
      options.forEach(option=>on(option,'change',()=>{
        if(page.hidden){update();return;}
        history.replaceState({...history.state},'',pageURL(location.href,option.dataset.handle));
        input.value=1;update();
      }));
      on(document,'th-bag-updated',event=>{bagItems=event.detail.items;update();});
      on(window,'popstate',event=>{
        renderRoute({focus:true});
        requestAnimationFrame(()=>window.scrollTo({top:page.hidden?(event.state?.thEntryScroll||0):0,behavior:'instant'}));
      });
      const addPackage=(option,qty=1)=>{
        const total=calculate(option,qty);if(!total)return;
        document.dispatchEvent(new CustomEvent('th-digital-preview-add',{detail:{id:'entry-'+option.value,title:total.title,price:total.cents/total.qty,qty:total.qty,entries:total.entries/total.qty,finish:option.dataset.entryFinish,kind:'digital'}}));
      };
      section.querySelectorAll('[data-entry-add]').forEach(button=>on(button,'click',()=>{
        const option=options.find(item=>item.value===button.dataset.entryAdd);if(option)addPackage(option);
      }));
      section.querySelectorAll('[data-entry-open]').forEach(button=>on(button,'click',event=>{
        if(event.button>0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
        const option=options.find(item=>item.value===button.dataset.entryOpen);if(!option)return;
        event.preventDefault();openPage(option);
      }));
      on(input,'input',update);on(input,'change',()=>{input.value=quantity(input.value);update();});
      on(minus,'click',()=>{input.value=quantity(Number(input.value)-1);update();});
      on(plus,'click',()=>{input.value=quantity(Number(input.value)+1);update();});
      on(review,'click',()=>{
        const total=update(),option=options.find(item=>item.checked);if(!total||!option)return;
        addPackage(option,total.qty);
      });
      const buyNow=section.querySelector('[data-entry-buy-now]');
      if(buyNow)on(buyNow,'click',()=>{const total=update(),option=options.find(item=>item.checked);if(!total||!option)return;addPackage(option,total.qty);document.dispatchEvent(new CustomEvent('th-test-checkout-request'));});
      on(document,'click',event=>{
        if(page.hidden||event.button>0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
        const link=event.target.closest('a[href]');if(!link)return;
        const url=new URL(link.href,location.href);
        if(url.origin!==location.origin||url.pathname!==location.pathname||!url.hash)return;
        const target=document.getElementById(url.hash.slice(1));if(!target)return;
        event.preventDefault();event.stopImmediatePropagation();
        url.searchParams.delete('quick_entry');history.pushState({...history.state},'',url.href);renderRoute();
        requestAnimationFrame(()=>{const offset=(document.querySelector('.section-header')?.getBoundingClientRect().height||70)+12;window.scrollTo({top:window.scrollY+target.getBoundingClientRect().top-offset,behavior:'instant'});});
      });
      selection.hidden=false;update();renderRoute();
      let observer;
      if(dock&&'IntersectionObserver' in window){const active=new Map();observer=new IntersectionObserver(entries=>{entries.forEach(entry=>active.set(entry.target,entry.isIntersecting));dock.hidden=[...active.values()].some(Boolean);});observer.observe(section);const hero=document.querySelector('[data-dream-hero]');if(hero)observer.observe(hero);dock.hidden=true;}
      section._entryDispose=()=>{observer?.disconnect();listeners.forEach(off=>off());if(dock)dock.hidden=true;delete section._entryDispose;};
    });
  }
  init();
  document.addEventListener('click',event=>{
    if(document.documentElement.classList.contains('th-quick-entry-view'))return;
    const link=event.target.closest('a[href="#entry-packages"]'),section=link&&document.getElementById('entry-packages');if(!section)return;
    event.preventDefault();event.stopImmediatePropagation();
    const offset=(document.querySelector('.section-header')?.getBoundingClientRect().height||70)+12;
    window.scrollTo({top:window.scrollY+section.getBoundingClientRect().top-offset,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  },true);
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-entry-packages]').forEach(section=>section._entryDispose?.()));
})();
